import {
  PopupsApi,
  ShowToastOptions,
  LikeDialogResult,
  CommentsPanelResult,
  LikeStateResult,
} from './PopupsApi'
import { MockOverlay } from '../MockOverlay'

export class MockPopupsApi implements PopupsApi {
  private readonly overlay: MockOverlay

  constructor(override: MockOverlay) {
    this.overlay = override
  }

  async showToast(
    message: string,
    options?: ShowToastOptions,
  ): Promise<boolean> {
    const variant = options?.variant ?? 'info'
    const duration = options?.duration ?? 3000
    const action = options?.action

    if (action) {
      const actionResult = window.confirm(
        `${message}\n\n[${action.label}] or [Cancel]`,
      )

      if (actionResult) {
        return true
      }
    }
    return false
  }

  async showLikeDialog(): Promise<LikeDialogResult> {
    return { shown: true, dismissed: false, liked: true }
  }

  async canShowLikeDialog(): Promise<{ available: boolean }> {
    return { available: true }
  }

  async showCommentsPanel(): Promise<CommentsPanelResult> {
    return { shown: true, dismissed: true }
  }

  async canShowCommentsPanel(): Promise<{ available: boolean }> {
    return { available: true }
  }

  async getLikeState(): Promise<LikeStateResult> {
    return { isLiked: false, likesCount: 0 }
  }
}
